<main class="pt-4">
  <content-with-tabs-v2 [tabLinks]="tabLinks" />
</main>
